import classNames from "classnames";
import React, { FC } from "react";

import { AVATAR_SIZE_VARIANTS } from "./Avatar.constants";
import { AvatarCountProps } from "./Avatar.types";

export const AvatarCount: FC<AvatarCountProps> = ({
  size = "md",
  avatarCountClassNames,
  count,
}) => {
  return (
    <div
      className={classNames(
        "flex items-center justify-center rounded-full bg-white text-[#253747]",
        AVATAR_SIZE_VARIANTS[size],
        avatarCountClassNames,
      )}>
      +{count}
    </div>
  );
};
